/* eslint-disable @typescript-eslint/naming-convention */
import { models } from '@ps/web-core-store';
import type { Select as CoreSelect, Slicer as CoreSlicer } from '@ps/web-core-store';

import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';

import type { CMSState } from './index';

type MappedSelect = {
  [key in keyof CoreSelect['cms']]: () => (
    rootState: RootState
  ) => ReturnType<CoreSelect['cms'][key]>;
};

const selectors = (slice: Slicer<CMSState>, createSelector: SelectorCreator) => ({
  ...(models.cms.selectors(
    slice as CoreSlicer<CMSState>,
    createSelector
  ) as unknown as MappedSelect)
});

export default selectors;
